module.exports = __webpack_public_path__ + "img/dashboard.2a7a8d2f.svg";